import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { StorageUtil } from '../store';

@Injectable()
export class StaffService {

  api = '/api/staff';

  constructor(
    private httpService: HttpService
  ) { }

  getTeams(clubID: number, userID: number) {
    return this.httpService.get(`${this.api}/get-teams/${clubID}/${userID}`);
  }

  removeTeams(ids: number[]) {
    return this.httpService.delete(`${this.api}/remove-teams/${ids.join(',')}`);
  }

  updateTeams(staffId: number, teamID: number, roles: number[]) {
    return this.httpService.post(`${this.api}/update-teams/${staffId}/${teamID}`, roles);
  }

  getRoles(clubID: number, userID: number) {
    return this.httpService.get(`${this.api}/get-roles/${clubID}/${userID}`);
  }
  getStaffRolesForTeamID(teamID: number, userID: number) {
    return this.httpService.get(`${this.api}/get-staff-roles-for-teamID/${teamID}/${userID}`);
  }

  updateRoles(clubID: number, userID: number, roles: number[], teamID = 0) {
    return this.httpService.post(`${this.api}/update-roles/${clubID}/${userID}`, roles, { params: { by: StorageUtil.userID, teamID } });
  }

  getClubPrograms(clubID: number) {
    return this.httpService.get(`${this.api}/get-club-programs/${clubID}`);
  }

  removeStaff(clubID: number, ids: number[]) {
    return this.httpService.delete(`${this.api}/remove-staff/${clubID}/${ids.join(',')}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/staff.service.ts